/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManualMxRewardCreateRequest
 */
export interface ManualMxRewardCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ManualMxRewardCreateRequest
     */
    creditCardProductName: string;
    /**
     * 
     * @type {string}
     * @memberof ManualMxRewardCreateRequest
     */
    institutionCode?: string;
    /**
     * The card's last four digits.
     * @type {string}
     * @memberof ManualMxRewardCreateRequest
     */
    accountNumber: string;
    /**
     * 
     * @type {number}
     * @memberof ManualMxRewardCreateRequest
     */
    balance?: number;
}

/**
 * Check if a given object implements the ManualMxRewardCreateRequest interface.
 */
export function instanceOfManualMxRewardCreateRequest(value: object): value is ManualMxRewardCreateRequest {
    if (!('creditCardProductName' in value) || value['creditCardProductName'] === undefined) return false;
    if (!('accountNumber' in value) || value['accountNumber'] === undefined) return false;
    return true;
}

export function ManualMxRewardCreateRequestFromJSON(json: any): ManualMxRewardCreateRequest {
    return ManualMxRewardCreateRequestFromJSONTyped(json, false);
}

export function ManualMxRewardCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualMxRewardCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'creditCardProductName': json['credit_card_product_name'],
        'institutionCode': json['institution_code'] == null ? undefined : json['institution_code'],
        'accountNumber': json['account_number'],
        'balance': json['balance'] == null ? undefined : json['balance'],
    };
}

export function ManualMxRewardCreateRequestToJSON(json: any): ManualMxRewardCreateRequest {
    return ManualMxRewardCreateRequestToJSONTyped(json, false);
}

export function ManualMxRewardCreateRequestToJSONTyped(value?: ManualMxRewardCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credit_card_product_name': value['creditCardProductName'],
        'institution_code': value['institutionCode'],
        'account_number': value['accountNumber'],
        'balance': value['balance'],
    };
}

